import React from "react";
import { LoadingComponent } from "@components";
import { FuncionarioDados, PlanoVinculadoEntidade, SaldoContribuicoesFaelceEntidade } from "@entidades";
import { Card } from "../Card";
import { WrapRow, AutoColumn } from "./styles";

interface Props {
  dados: FuncionarioDados | undefined;
  plano: PlanoVinculadoEntidade | undefined;
  tempoPlano: string;
  SRC: number;
  saldo: SaldoContribuicoesFaelceEntidade | undefined;
  idadeCompleta: string;
  tempoPatrocinadora: string;
}

export const Header: React.FC<Props> = ({
  dados,
  plano,
  tempoPlano,
  SRC,
  saldo,
  idadeCompleta,
  tempoPatrocinadora
}) => {

  function ToMoney(Valor: number) {
    return (
      Valor.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    );
  }

  if (dados === undefined || plano === undefined || saldo === undefined) {
    return (
      <LoadingComponent />
    );
  }

  return (
    <WrapRow>
      <WrapRow>
        <AutoColumn>
          <Card titulo={"Data de Nascimento"}>
            {dados.DadosPessoais.DT_NASCIMENTO}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Idade Atual"}>
            {idadeCompleta}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Sexo"}>
            {dados.SEXO}
          </Card>
        </AutoColumn>
      </WrapRow>

      <WrapRow>
        <AutoColumn>
          <Card titulo={"Data de Inscrição"} subTitulo={"(Plano)"}>
            {plano.DT_INSC_PLANO}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Tempo de Plano"}>
            {tempoPlano}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Data de Admissão"} subTitulo={"(Patrocinadora)"}>
            {dados.Funcionario.DT_ADMISSAO}
          </Card>
        </AutoColumn>
      </WrapRow>

      <WrapRow>
        <AutoColumn>
          <Card titulo={"Tempo de Patrocinadora"}>
            {tempoPatrocinadora}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Salário Real de Contribuição"}>
            R$ {ToMoney(SRC)}
          </Card>
        </AutoColumn>

        <AutoColumn>
          <Card titulo={"Provisão Matemática Programada (atual)"}>
            R$ {ToMoney(saldo.ContribTotal)}
          </Card>
        </AutoColumn>
      </WrapRow>
    </WrapRow>
  );
}